<template>
    <div class="properties">
        <div class="properties__menu properties-menu">
            <ul class="properties-menu__list">
                <li
                    v-for="(listComponent) in listComponents"
                    @click="scrollTo(listComponent.name)"
                    class="properties-menu__item"
                    :class="listComponent.iconClass"
                >
                </li>
            </ul>
        </div>
        <div class="properties__wrapper">
            <h3 class="properties__header">
                {{ $t('translation.blockProperties') }}
            </h3>

            <div @scroll="scroll($event)" id="body" class="properties__body">
                <div @click="scrollTo(offsetBody-300)" v-if="offsetBody > 0" class="properties__up"></div>
                <div class="col">
                    <template
                        v-for="(listComponent, index) in listComponents"
                    >
                        <div
                            v-if="listComponent.type === 'radio'"
                            :id="listComponent.name"
                            class="properties__item"
                        >
                            <h4 class="properties__sub-header">{{ listComponent.title }}</h4>

                            <div class="properties__port level">
                                <ul class="level__list">
                                    <li v-for="item in listComponent.data"
                                        @click="changeRadioItem(item, index)"
                                        class="level__item"
                                        :class="{ 'active': item[1] === listComponent.value}"
                                    >
                                        {{ item[0] }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div
                            v-if="listComponent.type === 'angle'"
                            :id="listComponent.name"
                            class="properties__item"
                        >
                            <h4 class="properties__sub-header">{{ listComponent.title }}</h4>

                            <p class="properties__angle-value">{{ listComponent.value }}&#176;</p>

                            <div class="properties__angle">
                                <circle-slider
                                    @input="selectAngle($event, index)"
                                    :value="listComponent.value"
                                    :side="120"
                                    :knob-radius="7"
                                    :min="-180"
                                    :max="180"
                                    :min-limit="listComponent.data.from"
                                    :max-limit="listComponent.data.to"
                                    :step-size="listComponent.data.step"
                                    circle-color="#393939"
                                    progress-color="#393939"
                                    knob-color="#2C2C2C"
                                ></circle-slider>
                            </div>
                        </div>

                        <div
                            v-if="listComponent.type === 'input'"
                            :id="listComponent.name"
                            class="properties__item"
                        >
                            <h4 class="properties__sub-header">{{ listComponent.title }}</h4>

                            <input
                                type="text"
                                class="properties__inputbox"
                                @input="setNewValue($event.target.value, index)"
                                :value="listComponent.value"
                            >
                        </div>

                        <div
                            v-if="listComponent.type === 'color'"
                            :id="listComponent.name"
                            class="properties__item"
                        >
                            <h4 class="properties__sub-header">{{ listComponent.title }}</h4>

                            <div class="properties__color">
                                <color-picker
                                    @input="selectColor($event, index)"
                                    :value="listComponent.value"
                                    :preview="true"
                                />
                            </div>
                        </div>

                        <div
                            v-if="listComponent.type === 'switch'"
                            :id="listComponent.name"
                            class="properties__item"
                        >
                            <h4 class="properties__sub-header">{{ listComponent.title }}</h4>

                            <div class="properties__direction checkbox">
                                <span class="checkbox__before">{{ listComponent.data[0][0] }}</span>
                                <label class="checkbox__container">
                                    <input @change="switchBlock($event.target.checked, index, listComponent.data)" :checked="listComponent.value" class="checkbox__input" type="checkbox">
                                    <span class="checkbox__item" />
                                </label>
                                <span class="checkbox__after">{{ listComponent.data[1][0] }}</span>
                            </div>
                        </div>

                        <div
                            v-if="listComponent.type === 'slider'"
                            :id="listComponent.name"
                            class="properties__item"
                        >
                            <h4 class="properties__sub-header">{{ listComponent.title }}</h4>

                            <!--<div class="properties__speed">-->
                                <!--<range-slider-->
                                    <!--@input="changeSlider($event, index)"-->
                                    <!--:value="listComponent.value"-->
                                    <!--:min="listComponent.data.from"-->
                                    <!--:max="listComponent.data.to"-->
                                    <!--:step="listComponent.data.step"-->
                                <!--/>-->
                            <!--</div>-->
                            <div class="properties__speed range-slider">
                                <div class="range-slider__wrapper">
                                    <span class="range-slider__from">{{ listComponent.data.from }}</span>
                                    <vue-slider ref="slider"
                                                @input="changeSlider($event, index)"
                                                :value="listComponent.value"
                                                :min="listComponent.data.from"
                                                :max="listComponent.data.to"
                                                :interval="listComponent.data.step"
                                                :direction="'vertical'"
                                                v-bind="options"></vue-slider>
                                    <span class="range-slider__to">{{ listComponent.data.to }}</span>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="listComponent.type === 'sound'"
                            :id="listComponent.name"
                            class="properties__item"
                        >
                            <h4 class="properties__sub-header">{{ listComponent.title }}</h4>

                            <div class="properties__sound list">
                                <ul class="list__list">
                                    <li v-for="item in listComponent.data"
                                        @click="changeSound(item, index)"
                                        class="list__item"
                                        :class="{ 'active': item[1] === listComponent.value}"
                                    >
                                        {{ item[0] }}
                                    </li>
                                </ul>
                                <div class="properties__sound-wrapper">
                                    <audio ref="audio" id="audio">
                                        <source :src="`${listComponent.value}`" type="audio/mp3">
                                    </audio>
                                    <button class="button-icon i-sound ml-3" @click="playAudio"></button>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="listComponent.type === 'list'"
                            :id="listComponent.name"
                            class="properties__item"
                        >
                            <h4 class="properties__sub-header">{{ listComponent.title }}</h4>

                            <div class="properties__list list">
                                <ul class="list__list">
                                    <li v-for="item in listComponent.data"
                                        @click="changeListItem(item, index)"
                                        class="list__item"
                                        :class="{ 'active': item[1] === listComponent.value}">
                                        <span v-html="textOrImage(item[0])"></span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div
                            v-if="listComponent.type === 'image'"
                            :id="listComponent.name"
                            class="properties__item"
                        >
                            <h4 class="properties__sub-header">{{ listComponent.title }}</h4>

                            <div class="properties__image list">
                                <ul class="list__list">
                                    <li v-for="item in listComponent.data"
                                        @click="changeImage(item, index)"
                                        class="list__item"
                                        :class="{ 'active': item[1] === listComponent.value}">
                                        {{ item[0] }}
                                    </li>
                                </ul>
                                <div class="properties__image-wrapper">
                                    <img :src="listComponent.value" class="properties__image-body">
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div @click="scrollTo(offsetBody+300)" v-if="offsetBody < bodyHeight" class="properties__down"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import ColorPicker from './ColorPicker';
    import RangeSlider from './RangeSlider';
    import CircleSlider from '../../../plugins/circlePicker/CircleSlider';
    import vueSlider from 'vue-slider-component';

    export default {
        props: {
            blockId: {
                type: String,
            },
            workspace: {
                required: false,
            },
            value: {
                required: false,
            },
            toolbox: {
                required: false,
            },
            fieldName: {
                required: false,
            },
            level: {
                required: false,
            },
        },
        components: {
            ColorPicker,
            RangeSlider,
            CircleSlider,
            vueSlider,
        },
        data () {
            return {
                offsetBody: 0,
                mount: false,
                options: {
                    width: 4,
                    height: 230,
                    tooltip: false,
                    sliderStyle: {
                        'background': 'url(./static/media/images/SliderButton.svg)',
                        'backgroundPosition': 'center',
                        'width': '27px',
                        'height': '40px',
                        'boxShadow': 'none',
                    },
                    bgStyle: {
                        'background': 'url(./static/media/images/SliderBg.svg)',
                        'width': '27px'
                    },
                    processStyle: {
                        'background': 'transparent',
                    },
                },
            }
        },
        computed: {
            bodyHeight() {
                if (this.mount) {
                    return $('#body')[0].scrollHeight - $('#body')[0].offsetHeight;
                }

                return 0;
            },
            listComponents() {
                const dropdownFields = [];

                this.workspace.getBlockById(this.blockId).inputList.forEach((elementInput) => {
                    elementInput.fieldRow.forEach((elementInputBlockly) => {
                        if (elementInputBlockly instanceof Blockly.FieldDropdown) {
                            dropdownFields.push(elementInputBlockly)
                        }
                    });
                });

                const list = [];
                let xml = Blockly.Xml.textToDom(this.value);
                let codeHtml = xml.querySelectorAll(`[id="${this.blockId}"] > field`);

                codeHtml.forEach((element, index) => {
                    const listLength = list.length;
                    const blockType = xml.querySelector(`[id="${this.blockId}"]`).getAttribute('type');
                    const name = element.getAttribute('name');

                    const isGaugeSlider = element.getAttribute('name').split('_')[1] === 'GAUGE';
                    const isInputBox = element.getAttribute('name').split('_')[1] === 'INPUTBOX';
                    const isSlider = element.getAttribute('name').split('_')[1] === 'SLIDER';
                    const isColor = element.getAttribute('name').split('_')[1] === 'COLOUR';

                    dropdownFields.forEach((dropdownField) => {
                        const isSoundList = element.getAttribute('name').split('_')[1] === 'SOUNDLIST';
                        const isImageList = element.getAttribute('name').split('_')[1] === 'IMGLIST';
                        const isRadioList = element.getAttribute('name').split('_')[1] === 'RADIO';
                        const isSwitchList = element.getAttribute('name').split('_')[1] === 'SWITCH';
                        const isBasicList = element.getAttribute('name').split('_')[1] === 'LIST';

                        if (element.getAttribute('name') === dropdownField.name) {
                            if (isSoundList) {
                                list.push({
                                    title: this.getBlockTitle(blockType, name, 'Sound'),
                                    iconClass: 'i-list',
                                    index,
                                    name: element.getAttribute('name'),
                                    type: 'sound',
                                    value: dropdownField.value_,
                                    data: dropdownField.menuGenerator_,
                                });
                            } else if (isImageList) {
                                list.push({
                                    title: this.getBlockTitle(blockType, name, 'Image'),
                                    iconClass: 'i-list',
                                    index,
                                    name: element.getAttribute('name'),
                                    type: 'image',
                                    value: dropdownField.value_,
                                    data: dropdownField.menuGenerator_,
                                });
                            } else if (isRadioList) {
                                list.push({
                                    title: this.getBlockTitle(blockType, name, 'Radio'),
                                    iconClass: 'i-port',
                                    index,
                                    name: element.getAttribute('name'),
                                    type: 'radio',
                                    value: dropdownField.value_,
                                    data: dropdownField.menuGenerator_,
                                });
                            } else if (isSwitchList) {
                                list.push({
                                    title: this.getBlockTitle(blockType, name, 'Switch'),
                                    iconClass: 'i-direction',
                                    index,
                                    name: element.getAttribute('name'),
                                    type: 'switch',
                                    value: dropdownField.value_ !== dropdownField.menuGenerator_[0][1],
                                    data: dropdownField.menuGenerator_,
                                });
                            } else if (isBasicList) {
                                list.push({
                                    title: this.getBlockTitle(blockType, name, 'List'),
                                    iconClass: 'i-list',
                                    index,
                                    name: element.getAttribute('name'),
                                    type: 'list',
                                    value: dropdownField.value_,
                                    data: dropdownField.menuGenerator_,
                                });
                            }
                        }
                    });

                    if (isGaugeSlider) {
                        list.push({
                            title: this.getBlockTitle(blockType, name, 'Angle'),
                            iconClass: 'i-angle',
                            index,
                            name: element.getAttribute('name'),
                            type: 'angle',
                            value: Number(element.textContent),
                            data: {
                                from: Number(element.getAttribute('name').split('_')[2]),
                                to: Number(element.getAttribute('name').split('_')[3]),
                                step: Number(element.getAttribute('name').split('_')[4]),
                            },
                        });
                    } else if (isInputBox) {
                        list.push({
                            title: this.getBlockTitle(blockType, name, 'Input'),
                            iconClass: 'i-list',
                            index,
                            name: element.getAttribute('name'),
                            type: 'input',
                            value: element.textContent,
                        });
                    } else if (isSlider) {
                        list.push({
                            title: this.getBlockTitle(blockType, name, 'Slider'),
                            iconClass: 'i-speed',
                            index,
                            name: element.getAttribute('name'),
                            type: 'slider',
                            value: Number(element.textContent),
                            data: {
                                from: Number(element.getAttribute('name').split('_')[2]),
                                to: Number(element.getAttribute('name').split('_')[3]),
                                step: Number(element.getAttribute('name').split('_')[4]),
                            },
                        });
                    } else if (element.getAttribute('name') === "COLOUR" || isColor) {
                        list.push({
                            title: this.getBlockTitle(blockType, name, 'Color'),
                            iconClass: 'i-color',
                            index,
                            name: element.getAttribute('name'),
                            type: 'color',
                            value: element.textContent,
                        });
                    }

                    if (listLength === list.length) {
                        list.push({
                            title: '',
                            iconClass: '',
                            index,
                            name: '',
                            type: 'empty',
                            value: '',
                        });
                    }
                });

                return list;
            },
        },
        methods: {
            scrollTo(y) {
                if (typeof y === 'number') {
                    $('#body').animate({scrollTop: y}, 400);
                } else {
                    let block =  $(`#${y}`);

                    if (block.length) {
                        $('#body').animate({scrollTop: block.offset().top + this.offsetBody - 90}, 400);
                    }
                }
            },
            setNewValue(newValue, index) {
                let xml = Blockly.Xml.textToDom(this.value);
                let codeHtml = xml.querySelectorAll(`[id="${this.blockId}"] > field`)[index];
                codeHtml.textContent = newValue.toString();
                Blockly.selected.getField(codeHtml.attributes.name.nodeValue).setValue(newValue.toString());
                this.$emit('input', Blockly.Xml.domToText(xml));
            },
            changeListItem(newValue, index) {
                this.setNewValue(newValue[1], index);
            },
            changeRadioItem(newValue, index) {
                this.setNewValue(newValue[1], index);
            },
            changeImage(newValue, index) {
                this.setNewValue(newValue[1], index);
            },
            playAudio() {
                this.$refs.audio[0].play();
            },
            switchBlock(newValue, index, allValues) {
                this.setNewValue(allValues[newValue ? 1 : 0][1], index);
            },
            changeSound(newValue, index) {
                this.setNewValue(newValue[1], index);

                this.$refs.audio[0].load();
                this.$refs.audio[0].play();
            },
            scroll(event) {
                this.offsetBody = event.target.scrollTop;
            },
            selectColor(newValue, index) {
                this.setNewValue(newValue, index);
            },
            selectAngle(newValue, index) {
                this.setNewValue(newValue, index);
            },
            changeSlider(newValue, index) {
                this.setNewValue(newValue, index);
            },
            textOrImage(item) {
                if (item.src !== undefined) {
                    return `<img src="${item.src}" width="${item.width}" width="${item.height}">`;
                } else {
                    return item;
                }
            },
            getBlockTitle(blockType, name, defaultName) {
                let title = null;

                for (let i = 0; i < this.toolbox.length; i++) {
                    let xml = Blockly.Xml.textToDom(this.toolbox[i]);

                    if (xml.querySelector(`block[type="${blockType}"]`) !== null) {
                        const jsonData = xml.querySelector(`block[type="${blockType}"]`).getAttribute('custom-data');

                        if (jsonData !== null) {
                            const data = JSON.parse(jsonData);

                            if (data[name] !== undefined) {
                                title = data[name][this.$i18n.locale];
                            }
                        }
                    }
                }

                return title || defaultName;
            },
        },
        mounted() {
            this.mount = true;

            this.scrollTo(this.fieldName);
        },
        updated() {
            this.$nextTick(() => {
                if (this.$refs.slider !== undefined) {
                    this.$refs.slider[0].refresh();
                }
            });
        },
        watch: {
            fieldName() {
                this.scrollTo(this.fieldName);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Code/properties/Properties.vue